/**************************************************
 * Nombre:       Tarjeta_Testimonio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Grid, Typography} from "@mui/material";

const Tarjeta_Testimonio = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#fff',
                borderRadius: 8,
                p: 4
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 20, fontWeight: 800}}>{item.frase}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                <Typography sx={{fontSize: 16, fontWeight: 400}}>{item.descripcion}</Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 2}}
            >

                <Grid container size={3} sx={{justifyContent: 'flex-start'}}>
                    <Avatar src={item.img} sx={{width: 60, height: 60,filter: 'grayscale(100%)' }}/>
                </Grid>

                <Grid container size={8} sx={{justifyContent: 'flex-start'}}>
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontWeight: 600}}>{item.nombre}</Typography>
                    </Grid>
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 14}}>{item.profesion}</Typography>
                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Testimonio    